export default __webpack_public_path__ + "static/media/Manual-1.6b914f95.png";